import styled from "@emotion/styled";
import { fonts } from "styles/fonts";

export const Wrapper = styled("div")`
  display: flex;
  justify-content: space-between;
  @media (max-width: 769px) {
    flex-direction: column;
  }
`;

export const OriginalImgWrap = styled("div")`
  max-width: ${(props) => props.width}px;
  width: 100%;
  .ReactCrop__crop-selection {
    border-radius: 10px;
  }
`;

export const BtnWrap = styled.div`
  float: right;
`;

export const Title = styled.div`
  font-family: ${fonts.robotoBold};
  font-size: 18;
  margin-bottom: 10px;
`;

export const Preview = styled.div`
  margin-left: 30px;
  @media (max-width: 769px) {
    margin-left: 0;
  }
`;
